import { makeStyles } from '@material-ui/core/styles';

export const useFormConfigurationStyles = makeStyles(theme => ({
  formConfiguration: {
    flexGrow: 1,
    padding: '16px !important'
  },
  tabsMinHeight: {
    minHeight: '22.1875rem'
  }
}));
